import {
  WFComponent,
  WFDynamicList,
  WFFormComponent,
  navigate,
} from "@xatom/core";
import stateArray from "../utils/statesArray";
import { publicQL } from "../../graphql";
import {
  Doctor,
  DoctorLocatorProviderListResponse,
  PublicGetProviderProfileInfoDocument,
  PublicLocateProviderListDocument,
} from "../../graphql/graphql";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { getGoogle } from "../utils/getGoogle";

import timezone from 'dayjs/plugin/timezone'
dayjs.extend(timezone)
dayjs.tz.setDefault('America/Chicago')

dayjs.extend(customParseFormat);
(window as any)["gg"] = dayjs;
const formatHour = (data: string) => {
  const _hours = {
    "sunday-open": "",
    "sunday-s": "",
    "sunday-e": "",
    "monday-open": "",
    "monday-s": "",
    "monday-e": "",
    "tuesday-open": "",
    "tuesday-s": "",
    "tuesday-e": "",
    "wednesday-open": "",
    "wednesday-s": "",
    "wednesday-e": "",
    "thursday-open": "",
    "thursday-s": "",
    "thursday-e": "",
    "friday-open": "",
    "friday-s": "",
    "friday-e": "",
    "saturday-open": "",
    "saturday-s": "",
    "saturday-e": "",
    ...JSON.parse(data || `{}`),
  };
  Object.keys(_hours)
    .filter((d) => !d.includes("open"))
    .forEach((d) => {
      console.log(
        _hours[d],
        dayjs(_hours[d], "HH:mm").format("hh:mm a")
      );
      _hours[d] = dayjs(_hours[d], "H:mm").format(
        "hh:mm a"
      );
    });
  const closed: string[] = [];
  const opened: string[] = [];
  if (_hours["sunday-open"] === "on") {
    opened.push(
      `Sunday - ${_hours["sunday-s"]} to ${_hours["sunday-e"]}`
    );
  } else {
    closed.push("sunday");
  }
  if (_hours["monday-open"] === "on") {
    opened.push(
      `Monday - ${_hours["monday-s"]} to ${_hours["monday-e"]}`
    );
  } else {
    closed.push("monday");
  }
  if (_hours["tuesday-open"] === "on") {
    opened.push(
      `Tuesday - ${_hours["tuesday-s"]} to ${_hours["tuesday-e"]}`
    );
  } else {
    closed.push("tuesday");
  }
  if (_hours["wednesday-open"] === "on") {
    opened.push(
      `Wednesday - ${_hours["wednesday-s"]} to ${_hours["wednesday-e"]}`
    );
  } else {
    closed.push("wednesday");
  }
  if (_hours["thursday-open"] === "on") {
    opened.push(
      `Thursday - ${_hours["thursday-s"]} to ${_hours["thursday-e"]}`
    );
  } else {
    closed.push("thursday");
  }
  if (_hours["friday-open"] === "on") {
    opened.push(
      `Friday - ${_hours["friday-s"]} to ${_hours["friday-e"]}`
    );
  } else {
    closed.push("friday");
  }
  if (_hours["saturday-open"] === "on") {
    opened.push(
      `Saturday - ${_hours["saturday-s"]} to ${_hours["saturday-e"]}`
    );
  } else {
    closed.push("saturday");
  }
  if (opened.length === 0) {
    return "N/A";
  }
  const _finalFormat = `Opened on \n${opened.join(
    `\n`
  )}\n\nClosed on \n${closed.join(", ")}`;
  return _finalFormat;
};

export const basicDoctorForm = () => {
  const form = new WFFormComponent<{
    zipcode: string;
    city: string;
    state: string;
  }>("#doctor-find");
  const stateField = new WFComponent("#state");

  stateArray.forEach((state) => {
    const option = document.createElement("option");
    option.value = state.value;
    option.textContent = state.name;
    stateField.getElement().appendChild(option);
  });
  form.onFormSubmit((data) => {
    
    if (data.city) {
      if (data.city.length === 0) {
        alert("Please select a city");
        return;
      }
    }
    if (data.state) {
      if (data.state.length === 0) {
        alert("Please enter a state");
        return;
      }
    }
    if (data.zipcode.length) {
      navigate(
        `/doctor-locator-results?zipcode=${data.zipcode}`
      );
    } else if (data.city.length && data.state.length) {
      navigate(
        `/doctor-locator-results?city=${data.city}&state=${data.state}`
      );
    } else {
      alert("Please enter a zip code or city and state");
    }
  });
};

export const doctorLocatorResult = (pageData: {
  zipcode: string;
  city: string;
  state: string;
}) => {
  getGoogle()
    .maps.importLibrary("maps")
    .then(({ Map }) => {
      let markers: { name: string; pid: string; m: any }[] =
        [];
      const mapContainer = new WFComponent(
        `[xa-type="map-container"]`
      );

      const map = new Map(mapContainer.getElement(), {
        center: { lat: 37.0902, lng: -95.7129 },
        zoom: 4,
      });

        window.map = map;
        window.markers = markers;
      const listReq = publicQL.mutation(
        PublicLocateProviderListDocument
      );
        listReq.onData((e) => {
        console.log("data", e);
        });
      const detailsReq = publicQL.query(
        PublicGetProviderProfileInfoDocument
      );

      const form = new WFFormComponent<{
        zipcode: string;
        city: string;
        state: string;
      }>("#doctor-find");
      const modalContainer = new WFComponent(
        `[xa-type="modal"]`
      );
      const closeButton1 =
        modalContainer.getChildAsComponent(`.popup_close`);
      const closeButton2 =
        modalContainer.getChildAsComponent(
          `.popup_footer-wrapper > a`
        );
      const modalBody = modalContainer.getChildAsComponent(
        `.popup_details-wrapper`
      );
      const modalLoading =
        modalContainer.getChildAsComponent(
          `.popup-loading-block`
        );
      const stateField = new WFComponent("#state");
      const resultText = new WFComponent(
        `[xa-type="result-text"]`
      );
      const mainContainer = new WFComponent(
        `[xa-type="main-container"]`
      );
      const list = new WFDynamicList<
        DoctorLocatorProviderListResponse,
        HTMLDivElement,
        HTMLDivElement,
        HTMLDivElement
      >(`[xa-type="list"]`, {
        rowSelector: `[xa-type="item"]`,
      });
      const slist = new WFDynamicList<
        { name: string; url: string },
        HTMLDivElement,
        HTMLDivElement,
        HTMLDivElement
      >(`.social-media-link-list`, {
        rowSelector: `.social-media-link-item`,
      });
      const plist = new WFDynamicList<
        Doctor,
        HTMLDivElement,
        HTMLDivElement,
        HTMLDivElement
      >(`.doctor-profile-list`, {
        rowSelector: `.doctor-profile-item`,
      });
      let autoSearch = false;

      const doSearch = () => {
        const _d = form.getFormData();
        listReq.fetch({
          postalCode: _d.zipcode,
          city: _d.city,
          state: _d.state,
        });
      };

      setTimeout(() => {
        if (pageData.zipcode) {
          form.setFromData({
            zipcode: pageData.zipcode,
          } as any);
          autoSearch = true;
        }
        if (pageData.city && pageData.state) {
          form.setFromData({
            city: pageData.city,
            state: pageData.state,
          } as any);
          autoSearch = true;
        }
        resultText.setText("");
  
        if (autoSearch) {
          doSearch();
        }
      }, 100);

      let dialogHeading = "";

      detailsReq.onError((err) => {
        console.log(err);
        alert("Failed to load details");
      });
      slist.rowRenderer(({ rowData, rowElement }) => {
        rowElement.updateTextVariable({
          value: rowData.name,
        });
        rowElement.setAttribute("href", rowData.url);
        rowElement.setAttribute("target", "_blank");
        return rowElement;
      });
      plist.rowRenderer(
        ({ rowData, rowElement, index }) => {
          const mainIndex = index;
          if (rowData.isPrimary) {
            rowElement.updateTextVariable({
              profileIndex: "Primary Doctor",
            });
          } else {
            rowElement.updateTextVariable({
              profileIndex: `${index}. Associate Doctor`,
            });
          }
          const diagnostics = new WFDynamicList<
            string,
            HTMLDivElement,
            HTMLDivElement,
            HTMLDivElement
          >(
            rowElement.getChildAsComponent(
              `[xa-type="diagnostics"]`
            ),
            { rowSelector: `.chip-item` }
          );
          diagnostics.rowRenderer(
            ({ rowData, rowElement }) => {
              rowElement.updateTextVariable({
                "c-text": rowData,
              });
              return rowElement;
            }
          );
          diagnostics.setData(
            JSON.parse(rowData.diagnostics || "[]")
          );
          const techniques = new WFDynamicList<
            string,
            HTMLDivElement,
            HTMLDivElement,
            HTMLDivElement
          >(
            rowElement.getChildAsComponent(
              `[xa-type="techniques"]`
            ),
            { rowSelector: `.chip-item` }
          );
          techniques.rowRenderer(
            ({ rowData, rowElement }) => {
              rowElement.updateTextVariable({
                "c-text": rowData,
              });
              return rowElement;
            }
          );
          techniques.setData(
            JSON.parse(rowData.techniques || "[]")
          );
          const modalities = new WFDynamicList<
            string,
            HTMLDivElement,
            HTMLDivElement,
            HTMLDivElement
          >(
            rowElement.getChildAsComponent(
              `[xa-type="modalities"]`
            ),
            { rowSelector: `.chip-item` }
          );
          modalities.rowRenderer(
            ({ rowData, rowElement }) => {
              rowElement.updateTextVariable({
                "c-text": rowData,
              });
              return rowElement;
            }
          );
          const offerings = new WFDynamicList<
            string,
            HTMLDivElement,
            HTMLDivElement,
            HTMLDivElement
          >(
            rowElement.getChildAsComponent(
              `[xa-type="offerings"]`
            ),
            { rowSelector: `.chip-item` }
          );
          offerings.rowRenderer(
            ({ rowData, rowElement }) => {
              rowElement.updateTextVariable({
                "c-text": rowData,
              });
              return rowElement;
            }
          );
          offerings.setData(
            JSON.parse(rowData.doYouOffer || "[]")
          );
          rowElement.updateTextVariable({
            fullName: rowData.fullName,
            website: rowData.website,
            hours: formatHour(rowData.hours),
            comment: rowData.additionalComments,
          });
          if (!rowData.website) {
            rowElement
              .getChildAsComponent(
                `[xa-type="website-link"]`
              )
              .getElement()
              .parentElement.remove();
          }
          if (!rowData.diagnostics) {
            diagnostics.getElement().parentElement.remove();
          }
          if (!rowData.techniques) {
            techniques.getElement().parentElement.remove();
          }
          if (!rowData.modalities) {
            modalities.getElement().parentElement.remove();
          }
          if (!rowData.doYouOffer) {
            offerings.getElement().parentElement.remove();
          }
          if (!rowData.additionalComments) {
            rowElement
              .getChildAsComponent(".comments")
              .getElement()
              .parentElement.remove();
          }
          return rowElement;
        }
      );
      detailsReq.onData((data) => {
        modalBody.removeCssClass("hide");
        modalLoading.addCssClass("hide");
        modalContainer.updateTextVariable({
          phone:
            data.publicGetProviderProfileInfo.phoneNumber ||
            "-",
          fax: data.publicGetProviderProfileInfo.fax || "-",
          officeHours: formatHour(
            data.publicGetProviderProfileInfo.officeHours
          ),
          website:
            data.publicGetProviderProfileInfo.website,
          address: `${data.publicGetProviderProfileInfo.mailAddress}, ${data.publicGetProviderProfileInfo.mailCity}, ${data.publicGetProviderProfileInfo.mailState} ${data.publicGetProviderProfileInfo.mailPostalCode}`,
        });
        if (
          data.publicGetProviderProfileInfo.socialMediaHandles.filter(
            (d) => d.url.length
          ).length === 0
        ) {
          new WFComponent(
            slist.getElement().parentElement.parentElement
          ).addCssClass("hide");
        } else {
          new WFComponent(
            slist.getElement().parentElement.parentElement
          ).removeCssClass("hide");
          slist.setData(
            data.publicGetProviderProfileInfo.socialMediaHandles
              .filter((d) => d.url.length)
              .map((d) => ({
                name: d.name,
                url: d.url,
              }))
          );
        }

        const primary =
          data.publicGetProviderProfileInfo.chiropractors.find(
            (d) => d.isPrimary
          );
        const associate =
          data.publicGetProviderProfileInfo.chiropractors.filter(
            (d) => !d.isPrimary
          );
        const finalDoctors = primary
          ? [primary, ...associate]
          : data.publicGetProviderProfileInfo.chiropractors;

        plist.setData(finalDoctors);
      });

      const showDialog = (providerId: string) => {
        modalContainer.updateTextVariable({
          providerName: dialogHeading,
        });
        modalBody.addCssClass("hide");
        modalLoading.removeCssClass("hide");
        modalContainer.removeCssClass("hide");

        detailsReq.fetch({ providerId });
      };

      const closeDialog = () => {
        modalBody.addCssClass("hide");
        modalLoading.removeCssClass("hide");
        modalContainer.addCssClass("hide");
      };

      closeButton1.on("click", () => {
        closeDialog();
      });
      closeButton2.on("click", () => {
        closeDialog();
      });

      stateArray.forEach((state) => {
        const option = document.createElement("option");
        option.value = state.value;
        option.textContent = state.name;
        stateField.getElement().appendChild(option);
      });
      form.onFormSubmit((data) => {
        if (listReq.isLoading()) {
          return;
        }
        if (data.city) {
          if (data.city.length === 0) {
            alert("Please select a city");
            return;
          }
        }
        if (data.state) {
          if (data.state.length === 0) {
            alert("Please enter a state");
            return;
          }
        }
        if (data.zipcode.length) {
          doSearch();
        } else if (data.city.length && data.state.length) {
          doSearch();
        } else {
          alert(
            "Please enter a zip code or city and state"
          );
        }
      });

      listReq.onLoadingChange((s) => {
        if (s) {
          form.disableForm();
        } else {
          form.enableForm();
        }
        form.updateSubmitButtonText(
          s ? "Please wait..." : "Find a Doctor"
        );
      });

      const infowindow = new (getGoogle().maps.InfoWindow)(
        {}
      );

      list.rowRenderer(({ rowData, rowElement, data }) => {
        const showBtn = rowElement.getChildAsComponent(
          `[xa-type="show-details"]`
        );
        const mapBtn = rowElement.getChildAsComponent(
          `[xa-type="show-on-map"]`
        );
        mapBtn.on("click", () => {
          if (
            rowData.provider.googleMapPlaceId &&
            rowData.provider.googleMapPlaceId.length &&
            rowData.provider.googleMapPlaceId.includes(",")
          ) {
            const m: any = data.filter(
              (d) => d.provider.id === rowData.provider.id
            );

            console.log("Mdata", m)

            loadMap({ data: m, showDetails: true})

            if (m.length) {
              console.log(m[0]);
              infowindow.setContent(
                `<h5>${
                  rowData.provider.practiceName
                }</h5><a href="https://www.google.com/maps/search/?api=1&query=${
                  rowData.provider.googleMapPlaceId.split(
                    ","
                  )[0]
                },${
                  rowData.provider.googleMapPlaceId.split(
                    ","
                  )[1]
                }" target="_blank">Click for Directions</a>`
              );
              infowindow.setZIndex(0);
              infowindow.setPosition({
                lat: parseFloat(
                  rowData.provider.googleMapPlaceId.split(
                    ","
                  )[0]
                ),
                lng: parseFloat(
                  rowData.provider.googleMapPlaceId.split(
                    ","
                  )[1]
                ),
              });
              infowindow.setOptions({
                pixelOffset: new (getGoogle().maps.Size)(
                  0,
                  -42
                ),
              });

              infowindow.open({
                anchor: m[0],
                map,
              });
            }
            map.panTo({
              lat: parseFloat(
                rowData.provider.googleMapPlaceId.split(
                  ","
                )[0]
              ),
              lng: parseFloat(
                rowData.provider.googleMapPlaceId.split(
                  ","
                )[1]
              ),
            });
          }
        });

        showBtn.on("click", () => {
          dialogHeading = `${rowData.provider.practiceName} - ${rowData.provider.providerId}`;
          showDialog(rowData.provider.id);
        });
        rowElement.updateTextVariable({
          providerName: rowData.provider.practiceName,
          address: `${rowData.provider.mailAddress}, ${rowData.provider.mailCity}, ${rowData.provider.mailState} - ${rowData.provider.mailPostalCode}`,
          miles: `${(rowData.distance || 0).toFixed(
            2
          )} miles`,
        });
        return rowElement;
      });

      function loadMap({ data, showDetails = false }) {

          console.log("DATA length", data.length)
          console.log("data length data", data)
          const bounds =
              new (getGoogle().maps.LatLngBounds)();

          if(showDetails) {
              console.log('showdetails', showDetails)
              for (let i = 0; i < markers.length; i++) {
                  markers[i].setMap(null);
              }
          }

          data
              .filter(
                  (d) => {
                      console.log("FILTER d", d)
                      return   d.provider.googleMapPlaceId &&
                          d.provider.googleMapPlaceId.length &&
                          d.provider.googleMapPlaceId.includes(",")
                  }
              )
              .map((d) => {
                  console.log("Data d", d)
                  return {
                      id: d.provider.id,
                      name: d.provider.practiceName,
                      lat: parseFloat(
                          d.provider.googleMapPlaceId.split(",")[0]
                      ),
                      lng: parseFloat(
                          d.provider.googleMapPlaceId.split(",")[1]
                      ),
                  };
              })
              .forEach(({ id, name, ...d }) => {

                  const m = new (getGoogle().maps.Marker)({
                      title: name,
                      position: d,
                      map,
                      zIndex: 100,
                  });

                  markers.push(m);
                  console.log(markers, 'markers')

                  m.addListener("click", () => {
                      infowindow.setOptions({
                          pixelOffset: new (getGoogle().maps.Size)(
                              0,
                              0
                          ),
                      });
                      infowindow.setContent(
                          `<h5>${name}</h5><a href="https://www.google.com/maps/search/?api=1&query=${d.lat},${d.lng}" target="_blank">Click for Directions</a>`
                      );
                      infowindow.open({
                          anchor: m,
                          map,
                      });
                  });
                  console.log("markers old data", markers)
                  console.log("showDetails", showDetails)
                  bounds.extend(d);
              });
          console.log("bounds", bounds)

          map.fitBounds(bounds);
          map.setZoom(Math.min(map.getZoom(), 17));
      }

      listReq.onData((data) => {
          console.log("Data", data)
        resultText.setText(
          data.publicLocateProviderList.length
            ? `Found ${data.publicLocateProviderList.length} results`
            : "No result found"
        );
        list.setData(
          data.publicLocateProviderList as DoctorLocatorProviderListResponse[]
        );
          // loadMap({ data: data.publicLocateProviderList })
      });

      mainContainer.removeCssClass("hide");
    })
    .catch(console.log);
};
